(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ao-cart-drawer"]) return;
  try {
    
  (function () {
    if (window.__aoCartDrawer) return;
    window.__aoCartDrawer = true;

    var SECTION = 'ao-cart-drawer';
    var DESKTOP = '(min-width: 768px)';
    var lastTrigger = null;
    var queue = Promise.resolve();
    var timers = {};
    var closeTimer = null;
    var openTimer = null;
    var openedAt = 0;
    var keyboardModality = false;

    function motion() {
      return window.AoMotion && window.AoMotion.enabled() ? window.AoMotion : null;
    }

    document.addEventListener('keydown', function (e) {
      if (e.metaKey || e.altKey || e.ctrlKey) return;
      keyboardModality = true;
      var d = drawer();
      if (d) d.removeAttribute('data-ao-quiet-focus');
    }, true);
    document.addEventListener('pointerdown', function () { keyboardModality = false; }, true);

    function root() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }
    function drawer() {
      return document.getElementById('AoCartDrawer');
    }
    function isOpen(d) {
      return !!(d && d.open);
    }
    function focusables(d) {
      return Array.prototype.filter.call(
        d.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'),
        function (el) { return el.offsetParent !== null || el === document.activeElement; }
      );
    }
    function announce(text) {
      var d = drawer();
      var live = d && d.querySelector('[data-ao-cart-live]');
      if (!live) return;
      live.textContent = '';
      window.setTimeout(function () { live.textContent = text; }, 60);
    }
    function msg(name, vars) {
      var d = drawer();
      var s = (d && d.getAttribute('data-msg-' + name)) || '';
      Object.keys(vars || {}).forEach(function (k) {
        s = s.split('[' + k + ']').join(vars[k]);
      });
      return s;
    }
    function lockScroll(on) {
      var html = document.documentElement;
      if (on) {
        var gap = window.innerWidth - html.clientWidth;
        html.style.overflow = 'hidden';
        if (gap > 0) document.body.style.paddingRight = gap + 'px';
      } else {
        html.style.overflow = '';
        document.body.style.paddingRight = '';
      }
    }

    function fallbackTarget() {
      var bags = document.querySelectorAll('[data-ao-cart-trigger], [data-ao-bag]');
      for (var i = 0; i < bags.length; i++) {
        if (bags[i].getClientRects().length) return bags[i];
      }
      var main = document.getElementById('MainContent');
      if (main && !main.hasAttribute('tabindex')) main.setAttribute('tabindex', '-1');
      return main;
    }

    function open(opts) {
      var d = drawer();
      if (!d || isOpen(d)) return;
      window.clearTimeout(closeTimer);
      var active = document.activeElement;
      lastTrigger = active && active !== document.body ? active : null;
      if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
      lockScroll(true);
      window.clearTimeout(openTimer);
      if (motion() && !(opts && opts.instant)) {
        openedAt = performance.now();
        d.style.removeProperty('--ao-cart-elapsed');
        d.setAttribute('data-ao-opening', '');
        openTimer = window.setTimeout(function () { d.removeAttribute('data-ao-opening'); }, 1800);
      }
      if (opts && opts.instant) d.classList.add('is-open');
      else window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { d.classList.add('is-open'); }); });
      var close = d.querySelector('.ao-cart__close');
      if (keyboardModality) d.removeAttribute('data-ao-quiet-focus'); else d.setAttribute('data-ao-quiet-focus', '');
      if (close) close.focus({ preventScroll: true, focusVisible: keyboardModality });
    }

    function close(opts) {
      var d = drawer();
      if (!isOpen(d)) return;
      window.clearTimeout(openTimer);
      d.removeAttribute('data-ao-opening');
      d.classList.remove('is-open');
      var panel = d.querySelector('.ao-cart__panel');
      var ms = panel ? parseFloat(getComputedStyle(panel).transitionDuration) * 1000 : 0;
      var finish = function () {
        if (d.classList.contains('is-open')) return;
        if (typeof d.close === 'function') d.close(); else d.removeAttribute('open');
        lockScroll(false);
        if (!(opts && opts.noFocus)) {
          var back = lastTrigger && document.contains(lastTrigger) && lastTrigger.getClientRects().length ? lastTrigger : fallbackTarget();
          if (back) back.focus({ preventScroll: true });
        }
        lastTrigger = null;
      };
      window.clearTimeout(closeTimer);
      if (opts && opts.instant) finish();
      else closeTimer = window.setTimeout(finish, ms || 0);
    }

    function swap(html) {
      var d = drawer();
      if (!d || !html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-ao-cart-body]');
      var body = d.querySelector('[data-ao-cart-body]');
      if (!fresh || !body) return;
      var active = document.activeElement;
      var focusId = active && body.contains(active) ? active.getAttribute('data-ao-focus') : null;
      var scroller = body.querySelector('.ao-cart__scroll');
      var scrollTop = scroller ? scroller.scrollTop : 0;
      var before = snapshot(body);
      var hadEmpty = !!body.querySelector('.ao-cart__empty');
      if (d.hasAttribute('data-ao-opening')) d.style.setProperty('--ao-cart-elapsed', Math.round(performance.now() - openedAt) + 'ms');
      body.innerHTML = fresh.innerHTML;
      animateChanges(d, body, before, hadEmpty);
      var nextScroller = body.querySelector('.ao-cart__scroll');
      if (nextScroller) nextScroller.scrollTop = scrollTop;
      if (focusId && isOpen(d)) {
        var target = body.querySelector('[data-ao-focus="' + focusId + '"]');
        if (!target || target.disabled) target = body.querySelector('[data-ao-remove], [data-ao-focus="empty-action"]') || d.querySelector('.ao-cart__close');
        if (target) target.focus({ preventScroll: true });
      }
    }

    function snapshot(body) {
      var lines = {};
      Array.prototype.forEach.call(body.querySelectorAll('[data-ao-cart-line]'), function (li) {
        var qty = li.querySelector('[data-ao-qty]');
        var price = li.querySelector('.ao-cart__price');
        lines[li.getAttribute('data-key')] = {
          qty: qty ? qty.defaultValue : '',
          price: price ? price.textContent.trim() : ''
        };
      });
      var sub = body.querySelector('.ao-cart__subtotal-value');
      var fill = body.querySelector('.ao-cart__fill');
      return {
        lines: lines,
        subtotal: sub ? sub.textContent.trim() : null,
        fill: fill ? getComputedStyle(fill).transform : null
      };
    }

    function animateChanges(d, body, before, hadEmpty) {
      var m = motion();
      if (!m) return;
      var opening = d.hasAttribute('data-ao-opening');
      Array.prototype.forEach.call(body.querySelectorAll('[data-ao-cart-line]'), function (li) {
        var prev = before.lines[li.getAttribute('data-key')];
        if (!prev) {
          if (!opening) m.enter(li);
          return;
        }
        var qty = li.querySelector('[data-ao-qty]');
        if (qty && qty.defaultValue !== prev.qty) m.swap(qty);
        var price = li.querySelector('.ao-cart__price');
        if (price && price.textContent.trim() !== prev.price) m.swap(price);
      });
      var sub = body.querySelector('.ao-cart__subtotal-value');
      if (sub && before.subtotal !== null && sub.textContent.trim() !== before.subtotal) m.swap(sub);
      var empty = body.querySelector('.ao-cart__empty');
      if (empty && !hadEmpty && !opening) m.enter(empty);
      var fill = body.querySelector('.ao-cart__fill');
      if (fill && before.fill && before.fill !== 'none') {
        var next = fill.style.transform;
        fill.style.transition = 'none';
        fill.style.transform = before.fill;
        fill.offsetWidth;
        fill.style.transition = '';
        fill.style.transform = next;
      }
    }

    function emit(cart) {
      document.dispatchEvent(new CustomEvent('ao:cart:updated', { detail: { cart: cart } }));
    }

    var busyCount = 0;
    function busy(on) {
      busyCount = Math.max(0, busyCount + (on ? 1 : -1));
      on = busyCount > 0;
      var d = drawer();
      var body = d && d.querySelector('[data-ao-cart-body]');
      if (!body) return;
      if (on) body.setAttribute('aria-busy', 'true'); else body.removeAttribute('aria-busy');
      Array.prototype.forEach.call(body.querySelectorAll('.ao-cart__subtotal-value'), function (el) {
        el.classList.toggle('ao-skeleton-text', !!on);
      });
      if (!on) {
        Array.prototype.forEach.call(body.querySelectorAll('.ao-cart__line--skeleton'), function (el) { el.remove(); });
      }
    }

    function skeletonLine() {
      var li = document.createElement('li');
      li.className = 'ao-cart__line ao-cart__line--skeleton';
      li.setAttribute('aria-hidden', 'true');
      li.innerHTML =
        '<div class="ao-cart__media ao-skeleton"></div>' +
        '<div class="ao-cart__info"><div class="ao-cart__skbar ao-skeleton" style="width:72%"></div>' +
        '<div class="ao-cart__skbar ao-skeleton" style="width:44%"></div>' +
        '<div class="ao-cart__skstep ao-skeleton"></div></div>' +
        '<div class="ao-cart__skprice ao-skeleton"></div>';
      return li;
    }

    function pending(item) {
      var d = drawer();
      var body = d && d.querySelector('[data-ao-cart-body]');
      if (!body) return;
      var existing = item && item.key ? body.querySelector('[data-ao-cart-line][data-key="' + String(item.key).replace(/"/g, '') + '"]') : null;
      if (existing) {
        existing.setAttribute('aria-busy', 'true');
      } else {
        var list = body.querySelector('.ao-cart__lines');
        if (!list) {
          var scroll = body.querySelector('.ao-cart__scroll');
          if (!scroll) return;
          list = document.createElement('ul');
          list.className = 'ao-cart__lines';
          list.setAttribute('role', 'list');
          scroll.replaceChildren(list);
        }
        list.insertBefore(skeletonLine(), list.firstChild);
      }
    }

    function refresh() {
      busy(true);
      queue = queue.then(function () {
        return Promise.all([
          fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }),
          fetch(root() + '?sections=' + SECTION).then(function (r) { return r.ok ? r.json() : {}; }).catch(function () { return {}; })
        ]).then(function (res) {
          swap(res[1] && res[1][SECTION]);
          busy(false);
          emit(res[0]);
          return res[0];
        });
      }).catch(function () { busy(false); });
      return queue;
    }

    function showError(line, text) {
      if (!line) return;
      var box = line.querySelector('[data-ao-cart-error]');
      var t = line.querySelector('[data-ao-cart-error-text]');
      if (!box || !t) return;
      t.textContent = text;
      box.hidden = false;
      announce(text);
    }

    function change(line, quantity) {
      var key = line.getAttribute('data-key');
      var title = line.getAttribute('data-title') || '';
      var previous = parseInt(line.getAttribute('data-qty-server') || '', 10);
      line.setAttribute('aria-busy', 'true');
      busy(true);
      queue = queue.then(function () {
        var request = fetch(root() + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity, sections: SECTION, sections_url: window.location.pathname })
        }).then(function (r) {
          return r.json().then(function (data) { return { ok: r.ok, status: r.status, data: data }; });
        });
        var m = motion();
        var collapsing = quantity === 0 && m ? m.collapse(line) : null;
        return Promise.all([request, collapsing]).then(function (all) { return all[0]; }).then(function (res) {
          if (!res.ok) {
            uncollapse(line);
            line.removeAttribute('aria-busy');
            busy(false);
            var input = line.querySelector('[data-ao-qty]');
            if (input && !isNaN(previous)) input.value = previous;
            showError(line, (res.data && (res.data.description || res.data.message)) || msg('error'));
            return;
          }
          var cart = res.data;
          swap(cart.sections && cart.sections[SECTION]);
          busy(false);
          delete cart.sections;
          emit(cart);
          announce(quantity === 0 ? msg('removed', { title: title }) : msg('quantity', { title: title, quantity: quantity }));
        });
      }).catch(function () {
        uncollapse(line);
        line.removeAttribute('aria-busy');
        busy(false);
        showError(line, msg('error'));
      });
      return queue;
    }

    function uncollapse(line) {
      if (!line.getAnimations) return;
      line.getAnimations().forEach(function (a) { a.cancel(); });
      line.style.overflow = '';
    }

    function schedule(line, quantity, delay) {
      var key = line.getAttribute('data-key');
      var err = line.querySelector('[data-ao-cart-error]');
      if (err) err.hidden = true;
      if (!line.hasAttribute('data-qty-server')) {
        var input = line.querySelector('[data-ao-qty]');
        line.setAttribute('data-qty-server', input ? input.defaultValue : '');
      }
      window.clearTimeout(timers[key]);
      timers[key] = window.setTimeout(function () {
        delete timers[key];
        change(line, quantity);
      }, delay);
    }

    document.addEventListener('ao:cart:open', function () { open(); refresh(); });
    document.addEventListener('ao:cart:added', function (e) {
      var wantOpen = window.matchMedia(DESKTOP).matches;
      pending(e.detail && e.detail.item);
      refresh();
      if (wantOpen) open();
    });

    document.addEventListener('click', function (e) {
      var d = drawer();
      if (!d || !d.contains(e.target)) return;
      if (e.target.closest('[data-ao-cart-close]')) { e.preventDefault(); close(); return; }
      var line = e.target.closest('[data-ao-cart-line]');
      if (!line) return;
      var step = e.target.closest('[data-ao-step]');
      if (step) {
        e.preventDefault();
        var input = line.querySelector('[data-ao-qty]');
        var next = Math.max(1, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-ao-step'), 10));
        input.value = next;
        var dec = line.querySelector('[data-ao-step="-1"]');
        if (dec) dec.disabled = next <= 1;
        schedule(line, next, 350);
        return;
      }
      if (e.target.closest('[data-ao-remove]')) {
        e.preventDefault();
        schedule(line, 0, 0);
      }
    });

    document.addEventListener('change', function (e) {
      var input = e.target.closest && e.target.closest('#AoCartDrawer [data-ao-qty]');
      if (!input) return;
      var n = parseInt(input.value, 10);
      if (isNaN(n) || n < 0) { input.value = input.defaultValue; return; }
      if (input.getAttribute('data-ao-sent') === String(n)) return;
      if (!input.hasAttribute('data-ao-sent') && String(n) === input.defaultValue) return;
      input.setAttribute('data-ao-sent', String(n));
      schedule(input.closest('[data-ao-cart-line]'), n, 0);
    });

    document.addEventListener('keydown', function (e) {
      var d = drawer();
      if (!isOpen(d)) return;
      if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-ao-qty]')) {
        e.preventDefault();
        e.target.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
      if (e.key !== 'Tab') return;
      var list = focusables(d);
      if (!list.length) return;
      var first = list[0];
      var last = list[list.length - 1];
      if (e.shiftKey && (document.activeElement === first || !d.contains(document.activeElement))) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && (document.activeElement === last || !d.contains(document.activeElement))) {
        e.preventDefault();
        first.focus();
      }
    });

    document.addEventListener('cancel', function (e) {
      if (e.target && e.target.id === 'AoCartDrawer') { e.preventDefault(); close(); }
    }, true);

    document.addEventListener('shopify:section:select', function (e) {
      if (e.detail && e.detail.sectionId === SECTION) open({ instant: true });
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      if (e.detail && e.detail.sectionId === SECTION) close({ instant: true, noFocus: true });
    });
    document.addEventListener('shopify:section:unload', function (e) {
      if (e.detail && e.detail.sectionId === SECTION) lockScroll(false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ao-catalogue-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ao-catalogue-sort')) {
    class AoCatalogueSort extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => this.onTab(event));
        window.addEventListener('pageshow', (event) => {
          if (event.persisted) this.restore();
        });
        this.select = this.querySelector('[data-ao-cg-sort]');
        this.grid = this.querySelector('[data-ao-cg-grid]');
        if (!this.select || !this.grid) return;
        this.select.closest('[hidden]')?.removeAttribute('hidden');
        this.select.addEventListener('change', () => this.sort(this.select.value));
      }

      onTab(event) {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const tab = event.target.closest('a.ao-ctabs__link');
        if (!tab || tab.getAttribute('aria-current') === 'page') return;
        if (tab.target && tab.target !== '_self') return;
        if (new URL(tab.href, location.href).origin !== location.origin) return;
        const results = this.querySelector('.ao-cat__results');
        if (!results) return;
        this.saved = { html: results.innerHTML, tabs: Array.from(this.querySelectorAll('.ao-ctabs__link')).map((l) => l.className) };
        this.querySelectorAll('.ao-ctabs__link').forEach((link) => {
          link.classList.remove('ao-ctabs__link--active');
        });
        tab.classList.add('ao-ctabs__link--active');
        results.setAttribute('aria-busy', 'true');
        const match = tab.textContent.match(/\((\d+)\)\s*$/);
        const n = Math.min(match ? Number(match[1]) : 8, 12);
        const show = () => {
          const spinner = document.createElement('span');
          spinner.className = 'ao-spinner ao-spinner--sm ao-ctabs__spinner';
          spinner.setAttribute('aria-hidden', 'true');
          tab.appendChild(spinner);
          const grid = results.querySelector('.ao-cat__grid');
          if (grid && n > 0 && window.AoLoad) grid.replaceChildren(window.AoLoad.skeletons(n, 'ao-cat__cell'));
        };
        if (this.cancelLoading) this.cancelLoading();
        this.cancelLoading = window.AoMotion ? window.AoMotion.later(show) : (show(), null);
      }

      restore() {
        if (this.cancelLoading) this.cancelLoading();
        this.cancelLoading = null;
        if (!this.saved) return;
        const results = this.querySelector('.ao-cat__results');
        if (results) {
          results.innerHTML = this.saved.html;
          results.removeAttribute('aria-busy');
          results.querySelectorAll('[data-ao-in="run"]').forEach((el) => el.setAttribute('data-ao-in', 'done'));
          if (window.AoMotion) window.AoMotion.reveal(results);
        }
        this.querySelectorAll('.ao-ctabs__spinner').forEach((el) => el.remove());
        this.querySelectorAll('.ao-ctabs__link').forEach((link, i) => {
          if (this.saved.tabs[i] !== undefined) link.className = this.saved.tabs[i];
        });
        this.grid = this.querySelector('[data-ao-cg-grid]');
        this.saved = null;
      }

      sort(mode) {
        const cells = Array.from(this.grid.children);
        const index = (el) => Number(el.dataset.aoIndex) || 0;
        const price = (el) => Number(el.dataset.aoPrice) || 0;
        cells.sort((a, b) => {
          if (mode === 'price-ascending') return price(a) - price(b) || index(a) - index(b);
          if (mode === 'price-descending') return price(b) - price(a) || index(a) - index(b);
          return index(a) - index(b);
        });
        this.grid.append(...cells);
        if (!window.AoMotion) return;
        const inView = cells.filter((el) => {
          const r = el.getBoundingClientRect();
          return r.bottom > 0 && r.top < window.innerHeight;
        });
        inView.forEach((el) => {
          el.setAttribute('data-ao-reveal', 'fade-up');
          el.removeAttribute('data-ao-t');
        });
        window.AoMotion.stagger(inView);
      }
    }
    customElements.define('ao-catalogue-sort', AoCatalogueSort);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ao-contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__aoBusySubmit) return;
    window.__aoBusySubmit = true;
    document.addEventListener('submit', function (e) {
      var btn = e.submitter;
      if (!btn || !btn.hasAttribute('data-ao-busy-submit')) return;
      var form = e.target;
      var set = function () {
        if (!btn.isConnected) return;
        // Shopify's storefront captcha cancels the native submit and re-submits after its check,
        // so a cancelled event is not a cancelled submission; only a declined confirm dialog is.
        if (e.defaultPrevented && form.hasAttribute('data-ao-confirm')) return;
        btn.setAttribute('aria-busy', 'true');
        setTimeout(function () { btn.removeAttribute('aria-busy'); }, 10000);
      };
      if (window.AoMotion && window.AoMotion.later) window.AoMotion.later(set);
      else setTimeout(set, 150);
    });
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      document.querySelectorAll('[data-ao-busy-submit][aria-busy="true"]').forEach(function (b) {
        b.removeAttribute('aria-busy');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ao-customer-account"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__aoBusySubmit) return;
    window.__aoBusySubmit = true;
    document.addEventListener('submit', function (e) {
      var btn = e.submitter;
      if (!btn || !btn.hasAttribute('data-ao-busy-submit')) return;
      var form = e.target;
      var set = function () {
        if (!btn.isConnected) return;
        // Shopify's storefront captcha cancels the native submit and re-submits after its check,
        // so a cancelled event is not a cancelled submission; only a declined confirm dialog is.
        if (e.defaultPrevented && form.hasAttribute('data-ao-confirm')) return;
        btn.setAttribute('aria-busy', 'true');
        setTimeout(function () { btn.removeAttribute('aria-busy'); }, 10000);
      };
      if (window.AoMotion && window.AoMotion.later) window.AoMotion.later(set);
      else setTimeout(set, 150);
    });
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      document.querySelectorAll('[data-ao-busy-submit][aria-busy="true"]').forEach(function (b) {
        b.removeAttribute('aria-busy');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ao-customer-activate"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__aoBusySubmit) return;
    window.__aoBusySubmit = true;
    document.addEventListener('submit', function (e) {
      var btn = e.submitter;
      if (!btn || !btn.hasAttribute('data-ao-busy-submit')) return;
      var form = e.target;
      var set = function () {
        if (!btn.isConnected) return;
        // Shopify's storefront captcha cancels the native submit and re-submits after its check,
        // so a cancelled event is not a cancelled submission; only a declined confirm dialog is.
        if (e.defaultPrevented && form.hasAttribute('data-ao-confirm')) return;
        btn.setAttribute('aria-busy', 'true');
        setTimeout(function () { btn.removeAttribute('aria-busy'); }, 10000);
      };
      if (window.AoMotion && window.AoMotion.later) window.AoMotion.later(set);
      else setTimeout(set, 150);
    });
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      document.querySelectorAll('[data-ao-busy-submit][aria-busy="true"]').forEach(function (b) {
        b.removeAttribute('aria-busy');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ao-customer-addresses"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__aoBusySubmit) return;
    window.__aoBusySubmit = true;
    document.addEventListener('submit', function (e) {
      var btn = e.submitter;
      if (!btn || !btn.hasAttribute('data-ao-busy-submit')) return;
      var form = e.target;
      var set = function () {
        if (!btn.isConnected) return;
        // Shopify's storefront captcha cancels the native submit and re-submits after its check,
        // so a cancelled event is not a cancelled submission; only a declined confirm dialog is.
        if (e.defaultPrevented && form.hasAttribute('data-ao-confirm')) return;
        btn.setAttribute('aria-busy', 'true');
        setTimeout(function () { btn.removeAttribute('aria-busy'); }, 10000);
      };
      if (window.AoMotion && window.AoMotion.later) window.AoMotion.later(set);
      else setTimeout(set, 150);
    });
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      document.querySelectorAll('[data-ao-busy-submit][aria-busy="true"]').forEach(function (b) {
        b.removeAttribute('aria-busy');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ao-customer-login"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__aoBusySubmit) return;
    window.__aoBusySubmit = true;
    document.addEventListener('submit', function (e) {
      var btn = e.submitter;
      if (!btn || !btn.hasAttribute('data-ao-busy-submit')) return;
      var form = e.target;
      var set = function () {
        if (!btn.isConnected) return;
        // Shopify's storefront captcha cancels the native submit and re-submits after its check,
        // so a cancelled event is not a cancelled submission; only a declined confirm dialog is.
        if (e.defaultPrevented && form.hasAttribute('data-ao-confirm')) return;
        btn.setAttribute('aria-busy', 'true');
        setTimeout(function () { btn.removeAttribute('aria-busy'); }, 10000);
      };
      if (window.AoMotion && window.AoMotion.later) window.AoMotion.later(set);
      else setTimeout(set, 150);
    });
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      document.querySelectorAll('[data-ao-busy-submit][aria-busy="true"]').forEach(function (b) {
        b.removeAttribute('aria-busy');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ao-customer-register"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__aoBusySubmit) return;
    window.__aoBusySubmit = true;
    document.addEventListener('submit', function (e) {
      var btn = e.submitter;
      if (!btn || !btn.hasAttribute('data-ao-busy-submit')) return;
      var form = e.target;
      var set = function () {
        if (!btn.isConnected) return;
        // Shopify's storefront captcha cancels the native submit and re-submits after its check,
        // so a cancelled event is not a cancelled submission; only a declined confirm dialog is.
        if (e.defaultPrevented && form.hasAttribute('data-ao-confirm')) return;
        btn.setAttribute('aria-busy', 'true');
        setTimeout(function () { btn.removeAttribute('aria-busy'); }, 10000);
      };
      if (window.AoMotion && window.AoMotion.later) window.AoMotion.later(set);
      else setTimeout(set, 150);
    });
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      document.querySelectorAll('[data-ao-busy-submit][aria-busy="true"]').forEach(function (b) {
        b.removeAttribute('aria-busy');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ao-customer-reset"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__aoBusySubmit) return;
    window.__aoBusySubmit = true;
    document.addEventListener('submit', function (e) {
      var btn = e.submitter;
      if (!btn || !btn.hasAttribute('data-ao-busy-submit')) return;
      var form = e.target;
      var set = function () {
        if (!btn.isConnected) return;
        // Shopify's storefront captcha cancels the native submit and re-submits after its check,
        // so a cancelled event is not a cancelled submission; only a declined confirm dialog is.
        if (e.defaultPrevented && form.hasAttribute('data-ao-confirm')) return;
        btn.setAttribute('aria-busy', 'true');
        setTimeout(function () { btn.removeAttribute('aria-busy'); }, 10000);
      };
      if (window.AoMotion && window.AoMotion.later) window.AoMotion.later(set);
      else setTimeout(set, 150);
    });
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      document.querySelectorAll('[data-ao-busy-submit][aria-busy="true"]').forEach(function (b) {
        b.removeAttribute('aria-busy');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ao-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__aoFaqToggle) return;
    window.__aoFaqToggle = true;
    document.addEventListener('toggle', function (e) {
      var item = e.target;
      if (item && item.hasAttribute && item.hasAttribute('data-ao-faq-initial')) item.removeAttribute('data-ao-faq-initial');
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ao-header"]) return;
  try {
    
  (function () {
    if (window.__aoHeaderBoot) return;
    window.__aoHeaderBoot = true;

    var bagQuery = window.matchMedia('(min-width: 768px)');
    var navQuery = window.matchMedia('(min-width: 1024px)');
    var rmQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function visible(el) {
      return el.getClientRects().length > 0;
    }

    function afterAnimation(el, done) {
      var finished = false;
      var timer = null;
      function finish() {
        if (finished) return;
        finished = true;
        window.clearTimeout(timer);
        el.removeEventListener('animationend', onEnd);
        done();
      }
      function onEnd(e) {
        if (e.target === el) finish();
      }
      var running = el.getAnimations ? el.getAnimations().length > 0 : true;
      if (!running) return finish();
      el.addEventListener('animationend', onEnd);
      timer = window.setTimeout(finish, 250);
      return finish;
    }

    function setSub(toggle, expand) {
      var sub = document.getElementById(toggle.getAttribute('aria-controls'));
      toggle.setAttribute('aria-expanded', expand ? 'true' : 'false');
      if (!sub) return;
      window.clearTimeout(sub.__aoTimer);
      if (expand) {
        sub.hidden = false;
        sub.offsetHeight;
        sub.setAttribute('data-open', '');
        return;
      }
      sub.removeAttribute('data-open');
      var ms = parseFloat(getComputedStyle(sub).transitionDuration) * 1000 || 0;
      if (!ms) {
        sub.hidden = true;
        return;
      }
      sub.__aoTimer = window.setTimeout(function () {
        if (!sub.hasAttribute('data-open')) sub.hidden = true;
      }, ms);
    }

    function setCount(root, n) {
      var badge = root.querySelector('[data-ao-bag-count]');
      var bag = root.querySelector('[data-ao-bag]');
      n = parseInt(n, 10) || 0;
      if (badge) {
        var changed = badge.textContent.trim() !== String(n);
        badge.textContent = String(n);
        badge.hidden = n === 0;
        if (changed && n > 0 && window.AoMotion) window.AoMotion.bump(badge);
      }
      if (bag) {
        var tpl = n === 1 ? bag.getAttribute('data-label-one') : bag.getAttribute('data-label-other');
        if (tpl) bag.setAttribute('aria-label', tpl.replace(/\d+/, String(n)));
      }
    }

    function init(root) {
      if (!root || root.__aoHeader) return;
      var openBtn = root.querySelector('[data-ao-menu-open]');
      var menu = root.querySelector('[data-ao-menu]');
      var closeBtn = root.querySelector('[data-ao-menu-close]');
      var bag = root.querySelector('[data-ao-bag]');

      var finishClose = null;

      function isOpen() {
        return menu && !menu.hidden && !menu.classList.contains('ao-mm--closing');
      }

      function onKey(e) {
        if (!isOpen()) return;
        if (e.key === 'Escape') {
          e.preventDefault();
          close(true);
          return;
        }
        if (e.key !== 'Tab') return;
        var items = Array.prototype.filter.call(menu.querySelectorAll(FOCUSABLE), visible);
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        var active = document.activeElement;
        if (!menu.contains(active)) {
          e.preventDefault();
          first.focus();
        } else if (e.shiftKey && active === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && active === last) {
          e.preventDefault();
          first.focus();
        }
      }

      function open() {
        if (!menu || isOpen() || navQuery.matches) return;
        if (finishClose) finishClose();
        menu.hidden = false;
        root.classList.add('ao-header--solid');
        openBtn.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('ao-scroll-lock');
        document.addEventListener('keydown', onKey);
        if (closeBtn) closeBtn.focus();
      }

      function close(restore, instant) {
        if (!isOpen()) return;
        root.classList.remove('ao-header--solid');
        openBtn.setAttribute('aria-expanded', 'false');
        document.removeEventListener('keydown', onKey);
        menu.inert = true;
        if (restore && visible(openBtn)) openBtn.focus();
        function done() {
          finishClose = null;
          menu.classList.remove('ao-mm--closing');
          menu.inert = false;
          menu.hidden = true;
          document.documentElement.classList.remove('ao-scroll-lock');
        }
        if (instant) return done();
        menu.classList.add('ao-mm--closing');
        finishClose = afterAnimation(menu, done) || null;
      }

      function bagMode() {
        if (!bag) return;
        if (bagQuery.matches && document.getElementById('AoCartDrawer')) {
          bag.setAttribute('role', 'button');
          bag.setAttribute('aria-haspopup', 'dialog');
        } else {
          bag.removeAttribute('role');
          bag.removeAttribute('aria-haspopup');
        }
      }

      function onNavChange() {
        if (navQuery.matches) close(false, true);
      }

      if (openBtn) openBtn.addEventListener('click', open);
      if (closeBtn) closeBtn.addEventListener('click', function () { close(true); });

      if (menu) {
        menu.addEventListener('click', function (e) {
          var toggle = e.target.closest('[data-ao-sub-toggle]');
          if (toggle) {
            setSub(toggle, toggle.getAttribute('aria-expanded') !== 'true');
            return;
          }
          var link = e.target.closest('a[href]');
          if (link) close(false);
        });
      }

      if (bag) {
        bag.addEventListener('click', function (e) {
          if (!bagQuery.matches || !document.getElementById('AoCartDrawer')) return;
          e.preventDefault();
          document.dispatchEvent(new CustomEvent('ao:cart:open', { detail: {} }));
        });
        bag.addEventListener('keydown', function (e) {
          if (e.key === ' ' && bag.getAttribute('role') === 'button') {
            e.preventDefault();
            bag.click();
          }
        });
      }

      bagQuery.addEventListener('change', bagMode);
      navQuery.addEventListener('change', onNavChange);
      bagMode();

      var sticky = root.classList.contains('ao-header--sticky');
      var section = root.parentElement;
      var ticking = false;
      var sizeObserver = null;

      function publishHeight() {
        var h = 0;
        if (sticky) {
          h = root.getBoundingClientRect().height;
        }
        document.documentElement.style.setProperty('--ao-header-h', Math.max(0, Math.round(h)) + 'px');
      }

      var start = 0;
      var range = 80;
      var lastP = -1;
      var useJs = false;

      function measure() {
        var prev = section.previousElementSibling;
        while (prev && !prev.getClientRects().length) prev = prev.previousElementSibling;
        start = prev ? Math.max(0, Math.round(prev.getBoundingClientRect().bottom + window.scrollY)) : 0;
        root.style.setProperty('--ao-hp-start', start + 'px');
        range = parseFloat(getComputedStyle(root).getPropertyValue('--ao-hp-range')) || 80;
        useJs = rmQuery.matches || !(window.CSS && CSS.supports && CSS.supports('animation-timeline: scroll()'));
        root.classList.toggle('ao-header--hp-js', useJs);
        if (!useJs) root.style.removeProperty('--ao-hp');
        lastP = -1;
      }

      function paintScroll() {
        ticking = false;
        var y = window.scrollY - start;
        var p = rmQuery.matches ? (y > 8 ? 1 : 0) : Math.min(1, Math.max(0, y / range));
        if (p === lastP) return;
        lastP = p;
        if (useJs) root.style.setProperty('--ao-hp', p.toFixed(3));
        if ((p >= 1) !== root.classList.contains('ao-header--scrolled')) {
          root.classList.toggle('ao-header--scrolled', p >= 1);
          publishHeight();
        }
      }
      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(paintScroll);
      }
      function onLayout() {
        if (sticky) {
          measure();
          paintScroll();
        }
        publishHeight();
      }
      if (sticky) {
        window.addEventListener('scroll', onScroll, { passive: true });
        rmQuery.addEventListener('change', onLayout);
      }
      onLayout();
      if (window.ResizeObserver) {
        sizeObserver = new ResizeObserver(onLayout);
        sizeObserver.observe(root);
      } else {
        window.addEventListener('resize', onLayout);
      }

      root.__aoHeader = {
        open: open,
        close: close,
        destroy: function () {
          close(false, true);
          bagQuery.removeEventListener('change', bagMode);
          navQuery.removeEventListener('change', onNavChange);
          window.removeEventListener('scroll', onScroll);
          window.removeEventListener('resize', onLayout);
          rmQuery.removeEventListener('change', onLayout);
          if (sizeObserver) sizeObserver.disconnect();
          document.documentElement.style.removeProperty('--ao-header-h');
        }
      };
    }

    function initAll() {
      document.querySelectorAll('[data-ao-header]').forEach(init);
      syncActive();
    }

    function normPath(p) {
      p = (p || '/').toLowerCase().replace(/\/+$/, '');
      return p || '/';
    }

    function collectionHandle(p) {
      var m = /^\/collections\/([^\/]+)/.exec(p);
      return m ? m[1] : null;
    }

    function syncActive() {
      var here = normPath(location.pathname);
      var hereHandle = collectionHandle(here);
      document.querySelectorAll('[data-ao-header] a.ao-header__link, [data-ao-header] a.ao-mm__row').forEach(function (a) {
        var target;
        try {
          target = new URL(a.getAttribute('href'), location.href);
        } catch (e) {
          return;
        }
        var match = false;
        if (target.origin === location.origin) {
          var path = normPath(target.pathname);
          var handle = collectionHandle(path);
          match = path === here || (handle !== null && handle === hereHandle && path === '/collections/' + handle);
        }
        if (match) {
          a.setAttribute('aria-current', 'page');
        } else {
          a.removeAttribute('aria-current');
        }
      });
    }

    if (!history.__aoLocationPatched) {
      history.__aoLocationPatched = true;
      ['pushState', 'replaceState'].forEach(function (name) {
        var original = history[name];
        if (typeof original !== 'function') return;
        history[name] = function () {
          var result = original.apply(this, arguments);
          try {
            window.dispatchEvent(new CustomEvent('ao:locationchange'));
          } catch (e) {}
          return result;
        };
      });
    }
    window.addEventListener('ao:locationchange', syncActive);
    window.addEventListener('popstate', syncActive);

    document.addEventListener('ao:cart:updated', function (e) {
      var cart = e.detail && e.detail.cart;
      if (!cart || typeof cart.item_count === 'undefined') return;
      document.querySelectorAll('[data-ao-header]').forEach(function (root) {
        setCount(root, cart.item_count);
      });
    });

    document.addEventListener('shopify:section:load', function (e) {
      init(e.target.querySelector('[data-ao-header]'));
    });
    document.addEventListener('shopify:section:unload', function (e) {
      var root = e.target.querySelector('[data-ao-header]');
      if (root && root.__aoHeader) root.__aoHeader.destroy();
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      var root = e.target.querySelector('[data-ao-header]');
      if (root && root.__aoHeader) root.__aoHeader.close(false, true);
    });
    document.addEventListener('shopify:block:select', function (e) {
      var root = e.target.closest('[data-ao-header]');
      if (!root || !root.__aoHeader) return;
      if (e.target.closest('[data-ao-menu]')) {
        root.__aoHeader.open();
        var sub = e.target.closest('.ao-mm__subwrap');
        if (sub) {
          var toggle = root.querySelector('[aria-controls="' + sub.id + '"]');
          if (toggle) setSub(toggle, true);
        }
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ao-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var FILL = 0.92;
    function fit(root) {
      (root || document).querySelectorAll('.ao-hero__arc-text').forEach(function (text) {
        var path = text.ownerSVGElement && text.ownerSVGElement.querySelector('path');
        if (!path) return;
        text.style.fontSize = '';
        var cs = getComputedStyle(text);
        var base = parseFloat(cs.fontSize);
        var len = text.getComputedTextLength() - text.getNumberOfChars() * (parseFloat(cs.letterSpacing) || 0);
        var max = path.getTotalLength() * FILL;
        if (len > max) text.style.fontSize = (base * max / len).toFixed(2) + 'px';
      });
    }
    function run(root) {
      fit(root);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fit(root); });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); });
    else run();
    if (document.fonts) document.fonts.addEventListener('loadingdone', function () { fit(); });
    document.addEventListener('shopify:section:load', function (e) { run(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ao-main-article"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Shopify's rich-text editor inserts images as a bare <img> (often inside a <p> or <div>),
    // so it has no caption. Where the image's alt says something the title does not, wrap it
    // in figure + figcaption so it reads like an authored caption. A blank alt, or one that
    // repeats the title, stays uncaptioned. Images already in a <figure> are left alone.
    function norm(t) {
      return (t || '').replace(/\s+/g, ' ').trim().toLowerCase();
    }

    function headerOffset(root) {
      var header = document.querySelector('.ao-header-root');
      if (!header) return;
      var host = header.closest('.shopify-section') || header;
      var pos = getComputedStyle(host).position;
      if (pos === 'sticky' || pos === 'fixed') {
        root.style.setProperty('--ao-art-offset', Math.round(host.getBoundingClientRect().height) + 'px');
      }
    }

    function captionImages(body) {
      var title = norm(body.getAttribute('data-ao-art-title'));
      Array.prototype.forEach.call(body.querySelectorAll('img'), function (img) {
        if (img.closest('figure')) return;
        var alt = (img.getAttribute('alt') || '').replace(/\s+/g, ' ').trim();
        if (!alt || norm(alt) === title) return;

        // Wrap the image's sole-child container (or a link around it) rather than nesting a
        // figure inside a <p>, which is invalid and would be split by the parser.
        var node = img.parentElement && img.parentElement.tagName === 'A' && img.parentElement.children.length === 1 ? img.parentElement : img;
        var holder = node.parentElement;
        var figure = document.createElement('figure');
        var caption = document.createElement('figcaption');
        caption.textContent = alt;
        if (holder && holder !== body && /^(P|DIV|SPAN)$/.test(holder.tagName) &&
            holder.children.length === 1 && holder.textContent.trim() === '' && holder.parentElement === body) {
          holder.parentNode.replaceChild(figure, holder);
        } else if (holder === body) {
          body.replaceChild(figure, node);
        } else {
          return;
        }
        figure.className = 'ao-art__inline-figure';
        figure.appendChild(node);
        figure.appendChild(caption);
      });
    }

    function init(root) {
      if (root.dataset.aoArtReady) return;
      root.dataset.aoArtReady = '1';
      headerOffset(root);
      var body = root.querySelector('[data-ao-art-body]');
      if (body) captionImages(body);
    }

    function boot() {
      document.querySelectorAll('[data-ao-article]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();

  (function () {
    if (window.__aoBusySubmit) return;
    window.__aoBusySubmit = true;
    document.addEventListener('submit', function (e) {
      var btn = e.submitter;
      if (!btn || !btn.hasAttribute('data-ao-busy-submit')) return;
      var form = e.target;
      var set = function () {
        if (!btn.isConnected) return;
        // Shopify's storefront captcha cancels the native submit and re-submits after its check,
        // so a cancelled event is not a cancelled submission; only a declined confirm dialog is.
        if (e.defaultPrevented && form.hasAttribute('data-ao-confirm')) return;
        btn.setAttribute('aria-busy', 'true');
        setTimeout(function () { btn.removeAttribute('aria-busy'); }, 10000);
      };
      if (window.AoMotion && window.AoMotion.later) window.AoMotion.later(set);
      else setTimeout(set, 150);
    });
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      document.querySelectorAll('[data-ao-busy-submit][aria-busy="true"]').forEach(function (b) {
        b.removeAttribute('aria-busy');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ao-main-cart"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__aoMainCart) return;
    window.__aoMainCart = true;

    var SOURCE = 'ao-main-cart';
    var queue = Promise.resolve();
    var timers = {};
    var noteTimer = null;

    function base() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }
    function sectionId(el) {
      return el.getAttribute('data-section-id');
    }
    function msg(el, name, vars) {
      var s = el.getAttribute('data-msg-' + name) || '';
      Object.keys(vars || {}).forEach(function (k) { s = s.split('[' + k + ']').join(vars[k]); });
      return s;
    }
    function announce(el, text) {
      var live = el.querySelector('[data-ao-mc-live]');
      if (!live) return;
      live.textContent = '';
      window.setTimeout(function () { live.textContent = text; }, 60);
    }
    function emit(cart) {
      document.dispatchEvent(new CustomEvent('ao:cart:updated', { detail: { cart: cart, source: SOURCE } }));
    }
    var busyCount = 0;
    function busy(el, on) {
      busyCount = Math.max(0, busyCount + (on ? 1 : -1));
      on = busyCount > 0;
      var body = el.querySelector('[data-ao-mc-body]');
      if (!body) return;
      if (on) body.setAttribute('aria-busy', 'true'); else body.removeAttribute('aria-busy');
      Array.prototype.forEach.call(body.querySelectorAll('.ao-mc__ledger .ao-mc__value, .ao-mc__ledger .ao-mc__grand'), function (v) {
        v.classList.toggle('ao-skeleton-text', !!on);
      });
    }

    function init() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-ao-main-cart]'), function (el) {
        el.classList.add('ao-mc--js');
      });
    }

    function moving() {
      return !!(window.AoMotion && window.AoMotion.enabled());
    }
    function later(fn) {
      if (window.AoMotion) return window.AoMotion.later(fn);
      var id = window.setTimeout(fn, 150);
      return function () { window.clearTimeout(id); };
    }
    function text(node) {
      return node ? node.textContent.replace(/\s+/g, ' ').trim() : '';
    }
    function snapshot(body) {
      var lines = {};
      Array.prototype.forEach.call(body.querySelectorAll('[data-ao-mc-line]'), function (li) {
        var q = li.querySelector('[data-ao-mc-qty]');
        lines[li.getAttribute('data-key')] = { total: text(li.querySelector('.ao-mc__total')), qty: q ? q.value : '' };
      });
      var track = body.querySelector('.ao-mc__track');
      return {
        lines: lines,
        ledger: Array.prototype.map.call(body.querySelectorAll('.ao-mc__ledger dd'), text),
        fill: track ? track.style.getPropertyValue('--ao-mc-p') : ''
      };
    }
    // Changes arrive as a fresh body: replay the catalogue motions on what changed.
    function animate(body, before) {
      if (!moving()) return;
      var M = window.AoMotion;
      Array.prototype.forEach.call(body.querySelectorAll('[data-ao-mc-line]'), function (li) {
        var prev = before.lines[li.getAttribute('data-key')];
        if (!prev) { M.enter(li); return; }
        var total = li.querySelector('.ao-mc__total');
        if (total && text(total) !== prev.total) M.swap(total);
        var q = li.querySelector('[data-ao-mc-qty]');
        if (q && q.value !== prev.qty) M.swap(q);
      });
      Array.prototype.forEach.call(body.querySelectorAll('.ao-mc__ledger dd'), function (dd, i) {
        if (before.ledger[i] !== undefined && text(dd) !== before.ledger[i]) M.swap(dd);
      });
      var track = body.querySelector('.ao-mc__track');
      if (track && before.fill) {
        var now = track.style.getPropertyValue('--ao-mc-p');
        if (now !== before.fill) {
          track.style.setProperty('--ao-mc-p', before.fill);
          void track.offsetWidth;
          track.style.setProperty('--ao-mc-p', now);
        }
      }
    }

    function swap(el, html) {
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-ao-mc-body]');
      var body = el.querySelector('[data-ao-mc-body]');
      if (!fresh || !body) return;
      var active = document.activeElement;
      var focusId = active && body.contains(active) ? active.getAttribute('data-ao-focus') : null;
      var before = snapshot(body);
      Array.prototype.forEach.call(fresh.querySelectorAll('[data-ao-reveal="settle"]'), function (n) { n.removeAttribute('data-ao-reveal'); });
      body.innerHTML = fresh.innerHTML;
      if (focusId) {
        var target = body.querySelector('[data-ao-focus="' + focusId + '"]');
        if (!target || target.disabled) target = body.querySelector('[data-ao-mc-remove], [data-ao-focus="empty-action"], [data-ao-focus="checkout"]');
        if (target) target.focus({ preventScroll: true });
      }
      animate(body, before);
      if (window.AoMotion) window.AoMotion.scan(body);
    }

    function refresh(el) {
      var id = sectionId(el);
      busy(el, true);
      queue = queue.then(function () {
        return fetch(window.location.pathname + '?sections=' + encodeURIComponent(id))
          .then(function (r) { return r.ok ? r.json() : {}; })
          .then(function (data) { swap(el, data && data[id]); busy(el, false); });
      }).catch(function () { busy(el, false); });
      return queue;
    }

    function showError(el, line, text) {
      var box = line.querySelector('[data-ao-mc-error]');
      var t = line.querySelector('[data-ao-mc-error-text]');
      if (box && t) {
        t.textContent = text;
        box.hidden = false;
      }
      announce(el, text);
    }

    function change(el, line, quantity) {
      var id = sectionId(el);
      var key = line.getAttribute('data-key');
      var title = line.getAttribute('data-title') || '';
      var previous = line.getAttribute('data-qty-server');
      var removing = quantity === 0;
      var gone = null;
      var stopSpin = function () {};
      line.setAttribute('aria-busy', 'true');
      if (removing && moving()) {
        line.classList.add('is-removing');
        gone = window.AoMotion.collapse(line);
      } else if (!removing) {
        stopSpin = later(function () { line.classList.add('is-spin'); });
      }
      var restore = function () {
        stopSpin();
        line.classList.remove('is-spin', 'is-removing');
        if (line.getAnimations) line.getAnimations().forEach(function (a) { a.cancel(); });
        line.style.overflow = '';
        line.removeAttribute('aria-busy');
      };
      busy(el, true);
      queue = queue.then(function () {
        return fetch(base() + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity, sections: id, sections_url: window.location.pathname })
        }).then(function (r) {
          return r.json().then(function (data) { return { ok: r.ok, data: data }; });
        }).then(function (res) {
          if (!res.ok) {
            restore();
            busy(el, false);
            var input = line.querySelector('[data-ao-mc-qty]');
            if (input && previous !== null) input.value = previous;
            showError(el, line, (res.data && (res.data.description || res.data.message)) || msg(el, 'error'));
            return;
          }
          var cart = res.data;
          return Promise.resolve(gone).then(function () {
            stopSpin();
            swap(el, cart.sections && cart.sections[id]);
            busy(el, false);
            delete cart.sections;
            emit(cart);
            announce(el, quantity === 0 ? msg(el, 'removed', { title: title }) : msg(el, 'quantity', { title: title, quantity: quantity }));
          });
        });
      }).catch(function () {
        restore();
        busy(el, false);
        showError(el, line, msg(el, 'error'));
      });
      return queue;
    }

    function schedule(el, line, quantity, delay) {
      var key = line.getAttribute('data-key');
      var err = line.querySelector('[data-ao-mc-error]');
      if (err) err.hidden = true;
      if (!line.hasAttribute('data-qty-server')) {
        var input = line.querySelector('[data-ao-mc-qty]');
        line.setAttribute('data-qty-server', input ? input.defaultValue : '');
      }
      window.clearTimeout(timers[key]);
      timers[key] = window.setTimeout(function () {
        delete timers[key];
        change(el, line, quantity);
      }, delay);
    }

    function saveNote(textarea) {
      window.clearTimeout(noteTimer);
      noteTimer = window.setTimeout(function () {
        fetch(base() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: textarea.value })
        }).catch(function () {});
      }, 400);
    }

    document.addEventListener('click', function (e) {
      var el = e.target.closest && e.target.closest('[data-ao-main-cart]');
      if (!el) return;
      var line = e.target.closest('[data-ao-mc-line]');
      if (!line) return;
      var step = e.target.closest('[data-ao-mc-step]');
      if (step) {
        e.preventDefault();
        var input = line.querySelector('[data-ao-mc-qty]');
        var next = Math.max(1, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-ao-mc-step'), 10));
        input.value = next;
        var dec = line.querySelector('[data-ao-mc-step="-1"]');
        if (dec) dec.disabled = next <= 1;
        schedule(el, line, next, 350);
        return;
      }
      if (e.target.closest('[data-ao-mc-remove]')) {
        e.preventDefault();
        schedule(el, line, 0, 0);
      }
    });

    document.addEventListener('change', function (e) {
      var input = e.target.closest && e.target.closest('[data-ao-main-cart] [data-ao-mc-qty]');
      if (!input) return;
      var el = input.closest('[data-ao-main-cart]');
      var n = parseInt(input.value, 10);
      if (isNaN(n) || n < 0) { input.value = input.defaultValue; return; }
      if (input.getAttribute('data-ao-sent') === String(n)) return;
      if (!input.hasAttribute('data-ao-sent') && String(n) === input.defaultValue) return;
      input.setAttribute('data-ao-sent', String(n));
      schedule(el, input.closest('[data-ao-mc-line]'), n, 0);
    });

    document.addEventListener('input', function (e) {
      var note = e.target.closest && e.target.closest('[data-ao-main-cart] [data-ao-mc-note]');
      if (note) saveNote(note);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var input = e.target.closest && e.target.closest('[data-ao-main-cart] [data-ao-mc-qty]');
      if (!input) return;
      e.preventDefault();
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    document.addEventListener('ao:cart:updated', function (e) {
      if (e.detail && e.detail.source === SOURCE) return;
      Array.prototype.forEach.call(document.querySelectorAll('[data-ao-main-cart]'), refresh);
    });

    document.addEventListener('shopify:section:load', init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ao-main-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!window.customElements || customElements.get('ao-collection-filters')) return;

    var swapController = null;
    var lastUrl = location.pathname + location.search;

    function parseSection(html, id) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      return doc.getElementById('shopify-section-' + id);
    }
    function tabCount(link) {
      var match = link && link.textContent.match(/\((\d+)\)\s*$/);
      return match ? Number(match[1]) : null;
    }
    function samePath(a, b) {
      return a.replace(/\/$/, '') === b.replace(/\/$/, '');
    }
    function findTab(host, url) {
      return Array.prototype.find.call(host.querySelectorAll('.ao-ctabs__link'), function (link) {
        return samePath(new URL(link.href, location.href).pathname, url.pathname);
      }) || null;
    }
    function isCatalogueUrl(url) {
      return url.origin === location.origin && url.pathname.indexOf('/collections/') !== -1;
    }
    function announce(host) {
      var count = host.querySelector('[data-ao-mc-count]');
      if (!count) return;
      var text = count.textContent;
      count.textContent = '';
      setTimeout(function () {
        if (window.AoMotion) window.AoMotion.swap(count, function () { count.textContent = text; });
        else count.textContent = text;
      }, 150);
    }
    function later(fn, ms) {
      if (window.AoMotion) return window.AoMotion.later(fn, ms);
      var id = setTimeout(fn, ms || 150);
      return function () { clearTimeout(id); };
    }
    function minHold() {
      var t = window.AoMotion && window.AoMotion.tokens;
      return (t && t.min) || 400;
    }
    // Fresh markup from the Section Rendering API: the static first row
    // only matters for LCP on a real page load, so after a swap every card
    // fades up (in-view cards as one staggered batch).
    function unsettle(root) {
      if (!root) return;
      root.querySelectorAll('.ao-cat__grid > .ao-cat__cell:not([data-ao-reveal])').forEach(function (el) {
        el.setAttribute('data-ao-reveal', 'fade-up');
      });
    }
    function arrive(root, headWrap) {
      if (!window.AoMotion) return;
      // The header settles as its own batch so the new cards start at
      // stagger index 0 instead of waiting behind the header's slots.
      if (headWrap) {
        window.AoMotion.scan(headWrap);
        window.AoMotion.reveal(headWrap, { instant: false });
      }
      window.AoMotion.scan(root);
    }
    function keepTabInView(host, scrollLeft) {
      var list = host.querySelector('.ao-ctabs__list');
      if (!list) return;
      list.scrollLeft = scrollLeft;
      var active = list.querySelector('[aria-current="page"]');
      if (!active) return;
      var l = active.offsetLeft;
      var r = l + active.offsetWidth;
      if (l < list.scrollLeft) list.scrollLeft = l;
      else if (r > list.scrollLeft + list.clientWidth) list.scrollLeft = r - list.clientWidth;
    }

    async function swapCatalogue(href, opts) {
      opts = opts || {};
      var url = new URL(href, location.href);
      var host = document.querySelector('ao-collection-filters');
      var mainWrap = host && host.closest('.shopify-section');
      if (!mainWrap || mainWrap.id.indexOf('shopify-section-') !== 0) {
        location.href = url.href;
        return;
      }
      var header = document.querySelector('.ao-ph');
      var headWrap = header && header.closest('.shopify-section');
      if (headWrap && headWrap.id.indexOf('shopify-section-') !== 0) headWrap = null;
      var wraps = headWrap ? [headWrap, mainWrap] : [mainWrap];
      var ids = wraps.map(function (w) { return w.id.replace(/^shopify-section-/, ''); });

      var hadFocus = host.contains(document.activeElement);
      var list = host.querySelector('.ao-ctabs__list');
      var tabScroll = list ? list.scrollLeft : 0;
      var tab = opts.tab || findTab(host, url);
      host.showLoading({ tab: tab, count: tab ? tabCount(tab) : null });

      if (host.controller) host.controller.abort();
      if (swapController) swapController.abort();
      var controller = (swapController = new AbortController());

      try {
        var fetchUrl = new URL(url.href);
        fetchUrl.hash = '';
        fetchUrl.searchParams.set('sections', ids.join(','));
        var response = await fetch(fetchUrl.href, { signal: controller.signal });
        if (!response.ok) throw new Error(String(response.status));
        var data = await response.json();
        var fresh = ids.map(function (id) { return data && data[id] ? parseSection(data[id], id) : null; });
        var freshMain = fresh[fresh.length - 1];
        if (fresh.indexOf(null) !== -1 || !freshMain.querySelector('ao-collection-filters')) throw new Error('section mismatch');
        await host.ready();
        if (controller !== swapController) return;
        swapController = null;

        unsettle(freshMain);
        wraps.forEach(function (wrap, i) { wrap.innerHTML = fresh[i].innerHTML; });
        var next = mainWrap.querySelector('ao-collection-filters');
        if (next.dataset.aoTitle) document.title = next.dataset.aoTitle;
        if (opts.push !== false) history.pushState({ aoCat: true }, '', url.pathname + url.search);
        lastUrl = url.pathname + url.search;
        keepTabInView(next, tabScroll);
        arrive(next, headWrap);
        if (hadFocus) {
          var active = next.querySelector('.ao-ctabs__link[aria-current="page"]');
          if (active) active.focus({ preventScroll: true });
        }
        announce(next);
      } catch (error) {
        if (error.name === 'AbortError') return;
        location.href = url.href;
      }
    }

    window.addEventListener('popstate', function () {
      var now = location.pathname + location.search;
      if (now === lastUrl) return;
      lastUrl = now;
      var host = document.querySelector('ao-collection-filters');
      if (!host) return;
      var base = new URL(host.dataset.baseUrl, location.origin).pathname;
      if (samePath(location.pathname, base)) host.load(location.href, { push: false });
      else swapCatalogue(location.href, { push: false });
    });

    class AoCollectionFilters extends HTMLElement {
      connectedCallback() {
        this.classList.add('ao-mc--js');
        this.sectionId = this.dataset.sectionId;
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onClose = this.onClose.bind(this);
        this.onWide = this.onWide.bind(this);
        this.addEventListener('change', this.onChange);
        this.addEventListener('submit', this.onSubmit);
        this.addEventListener('click', this.onClick);
        // `cancel` and `close` do not bubble; capture catches them on the host.
        this.addEventListener('cancel', this.onCancel, true);
        this.addEventListener('close', this.onClose, true);
        this.wide = window.matchMedia('(min-width: 1024px)');
        this.wide.addEventListener('change', this.onWide);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
        this.removeEventListener('submit', this.onSubmit);
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('cancel', this.onCancel, true);
        this.removeEventListener('close', this.onClose, true);
        if (this.wide) this.wide.removeEventListener('change', this.onWide);
        clearTimeout(this.sheetTimer);
        this.lockScroll(false);
        if (this.controller) this.controller.abort();
        if (this.loading && this.loading.cancel) this.loading.cancel();
      }

      sheet() {
        return this.querySelector('[data-ao-mc-sheet]');
      }

      // Open while shown or opening; a closing sheet has lost data-ao-open.
      sheetOpen() {
        const sheet = this.sheet();
        return !!(sheet && sheet.open && sheet.hasAttribute('data-ao-open'));
      }

      lockScroll(on) {
        const root = document.documentElement;
        if (on && !this.locked) {
          const bar = window.innerWidth - root.clientWidth;
          this.locked = true;
          root.style.overflow = 'hidden';
          if (bar > 0) root.style.paddingRight = bar + 'px';
        } else if (!on && this.locked) {
          this.locked = false;
          root.style.overflow = '';
          root.style.paddingRight = '';
        }
      }

      openSheet() {
        const sheet = this.sheet();
        if (!sheet || typeof sheet.showModal !== 'function') return;
        clearTimeout(this.sheetTimer);
        if (!sheet.open) {
          this.lockScroll(true);
          sheet.removeAttribute('role');
          sheet.showModal();
          sheet.offsetWidth;
        }
        sheet.setAttribute('data-ao-open', '');
      }

      closeSheet() {
        const sheet = this.sheet();
        if (!sheet || !sheet.open || !sheet.hasAttribute('data-ao-open')) return;
        sheet.removeAttribute('data-ao-open');
        const panel = sheet.querySelector('.ao-mc__panel') || sheet;
        const ms = Math.max(0, ...getComputedStyle(panel).transitionDuration.split(',').map((s) => parseFloat(s) * 1000 || 0));
        clearTimeout(this.sheetTimer);
        this.sheetTimer = setTimeout(() => this.finishClose(sheet, true), ms + 20);
      }

      finishClose(sheet, refocus) {
        clearTimeout(this.sheetTimer);
        sheet.removeAttribute('data-ao-open');
        if (sheet.open) sheet.close();
        sheet.setAttribute('role', 'group');
        this.lockScroll(false);
        if (!refocus) return;
        const opener = this.querySelector('[data-ao-mc-open]');
        if (opener) opener.focus({ preventScroll: true });
      }

      onCancel(event) {
        if (!event.target.matches || !event.target.matches('[data-ao-mc-sheet]')) return;
        event.preventDefault();
        this.closeSheet();
      }

      // Closed by something other than closeSheet (e.g. a platform back
      // gesture that cannot be cancelled): keep state and scroll in step.
      onClose(event) {
        if (!event.target.matches || !event.target.matches('[data-ao-mc-sheet]')) return;
        event.target.removeAttribute('data-ao-open');
        event.target.setAttribute('role', 'group');
        this.lockScroll(false);
      }

      onWide() {
        const sheet = this.sheet();
        if (this.wide.matches && sheet && sheet.open) this.finishClose(sheet, false);
      }

      // While the sheet is open the dialog must stay in the top layer, so a
      // filter change replaces only the marked regions (facets, sheet footer,
      // filter/sort row, count, results) instead of the whole host.
      patch(next) {
        const sheet = this.sheet();
        const active = document.activeElement;
        let keepId = '';
        if (active && this.contains(active)) {
          const select = active.closest('ao-select');
          keepId = select && select.querySelector('select') ? select.querySelector('select').id : active.id;
        }
        Array.from(this.querySelectorAll('[data-ao-mc-region]')).forEach((el) => {
          const fresh = next.querySelector('[data-ao-mc-region="' + el.getAttribute('data-ao-mc-region') + '"]');
          if (fresh) el.replaceWith(fresh);
        });
        const keep = keepId && document.getElementById(keepId);
        if (keep && sheet.contains(keep)) keep.focus({ preventScroll: true });
        else if (!sheet.contains(document.activeElement)) {
          const show = sheet.querySelector('.ao-mc__sheet-show');
          if (show) show.focus({ preventScroll: true });
        }
      }

      formUrl(form) {
        const params = new URLSearchParams();
        new FormData(form).forEach((value, key) => {
          if (String(value).trim() !== '') params.append(key, value);
        });
        const query = params.toString();
        return this.dataset.baseUrl + (query ? '?' + query : '');
      }

      onChange(event) {
        const form = event.target.closest('[data-ao-mc-form]');
        if (!form) return;
        this.load(this.formUrl(form), { focusId: event.target.id });
      }

      onSubmit(event) {
        const form = event.target.closest('[data-ao-mc-form]');
        if (!form) return;
        event.preventDefault();
        const active = document.activeElement;
        this.load(this.formUrl(form), { focusId: active && this.contains(active) ? active.id : '' });
      }

      onClick(event) {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (event.target.closest('[data-ao-mc-open]')) {
          event.preventDefault();
          this.openSheet();
          return;
        }
        if (event.target.closest('[data-ao-mc-close]')) {
          event.preventDefault();
          this.closeSheet();
          return;
        }
        const tab = event.target.closest('a.ao-ctabs__link');
        if (tab) {
          if (tab.target && tab.target !== '_self') return;
          const url = new URL(tab.href, location.href);
          if (!isCatalogueUrl(url)) return;
          event.preventDefault();
          if (url.pathname + url.search === location.pathname + location.search) return;
          swapCatalogue(url.href, { tab: tab });
          return;
        }
        const link = event.target.closest('a[data-ao-mc-link]');
        if (!link) return;
        event.preventDefault();
        this.load(link.href, { scroll: link.hasAttribute('data-ao-mc-scroll') });
      }

      markTab(tab) {
        const nav = tab.closest('.ao-ctabs');
        if (nav) {
          nav.querySelectorAll('.ao-ctabs__link').forEach((link) => {
            link.classList.remove('ao-ctabs__link--active');
            link.removeAttribute('aria-current');
          });
          nav.querySelectorAll('.ao-ctabs__spinner').forEach((el) => el.remove());
        }
        tab.classList.add('ao-ctabs__link--active');
        tab.setAttribute('aria-current', 'page');
      }

      // Delayed loading UI (docs/motion.md §4.7, §4.16): the old grid dims
      // to .5 at once; the tab/count spinners and the skeleton grid appear
      // only if the response takes longer than --loading-delay, and once
      // shown they stay at least --loading-min (see ready()).
      showLoading({ tab = null, count = null } = {}) {
        if (this.loading && this.loading.cancel) this.loading.cancel();
        const state = (this.loading = { shownAt: 0 });
        if (tab) this.markTab(tab);
        const results = this.querySelector('[data-ao-mc-results]');
        if (results) results.setAttribute('aria-busy', 'true');
        state.cancel = later(() => {
          state.shownAt = performance.now();
          if (tab && tab.isConnected) {
            const spinner = document.createElement('span');
            spinner.className = 'ao-spinner ao-spinner--sm ao-ctabs__spinner';
            spinner.setAttribute('aria-hidden', 'true');
            tab.appendChild(spinner);
          }
          const count_el = this.querySelector('[data-ao-mc-count]');
          if (count_el) count_el.classList.add('is-loading');
          const show = this.sheetOpen() && this.querySelector('.ao-mc__sheet-show');
          if (show) {
            const spinner = document.createElement('span');
            spinner.className = 'ao-spinner ao-spinner--sm';
            spinner.setAttribute('aria-hidden', 'true');
            show.appendChild(spinner);
            show.setAttribute('aria-busy', 'true');
          }
          if (results) this.showSkeletons(results, count);
        });
      }

      showSkeletons(results, count) {
        if (!window.AoLoad) return;
        let grid = results.querySelector('.ao-cat__grid');
        const shown = grid ? grid.querySelectorAll('.ao-cat__cell:not([data-ao-skeleton])').length : 0;
        const perPage = Number(this.dataset.perPage) || 24;
        let n = count !== null ? count : shown || 8;
        n = Math.min(n, perPage, 12);
        if (n < 1) return;
        const skeletons = window.AoLoad.skeletons(n, 'ao-cat__cell');
        if (grid) {
          grid.replaceChildren(skeletons);
        } else {
          grid = document.createElement('ul');
          grid.className = 'ao-cat__grid' + (this.dataset.cols === '3' ? ' ao-cat__grid--cols-3' : '');
          grid.setAttribute('role', 'list');
          grid.appendChild(skeletons);
          results.replaceChildren(grid);
        }
      }

      // Resolves when the response may replace the loading UI: at once if
      // the skeletons never showed, else after their minimum display time.
      ready() {
        const state = this.loading;
        this.loading = null;
        if (!state) return Promise.resolve();
        if (state.cancel) state.cancel();
        const wait = state.shownAt ? minHold() - (performance.now() - state.shownAt) : 0;
        return wait > 0 ? new Promise((resolve) => setTimeout(resolve, wait)) : Promise.resolve();
      }

      async load(href, { push = true, focusId = '', scroll = false } = {}) {
        const url = new URL(href, location.origin);
        const fetchUrl = new URL(url);
        fetchUrl.searchParams.set('section_id', this.sectionId);
        if (swapController) swapController.abort();
        if (this.controller) this.controller.abort();
        const controller = (this.controller = new AbortController());
        this.showLoading();
        try {
          const response = await fetch(fetchUrl, { signal: controller.signal });
          if (!response.ok) throw new Error(response.status);
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const next = doc.querySelector('ao-collection-filters');
          if (!next) throw new Error('missing section');
          await this.ready();
          if (controller.signal.aborted) return;
          unsettle(next);
          const sheetOpen = this.sheetOpen();
          let refocusOpener = false;
          if (sheetOpen) {
            this.patch(next);
          } else {
            const sheet = this.sheet();
            if (sheet && sheet.open) {
              this.finishClose(sheet, false);
              refocusOpener = true;
            }
            this.innerHTML = next.innerHTML;
          }
          if (refocusOpener) {
            const opener = this.querySelector('[data-ao-mc-open]');
            if (opener) opener.focus({ preventScroll: true });
            focusId = '';
          }
          if (next.dataset.aoTitle) document.title = next.dataset.aoTitle;
          announce(this);
          if (push) history.pushState({ aoMc: true }, '', url.pathname + url.search);
          lastUrl = url.pathname + url.search;
          arrive(this);
          if (focusId && !sheetOpen) {
            const el = document.getElementById(focusId);
            if (el) el.focus({ preventScroll: true });
          }
          if (scroll) {
            const top = this.getBoundingClientRect().top + window.scrollY;
            const smooth = !(window.AoLoad && window.AoLoad.reduced());
            window.scrollTo({ top: Math.max(0, top - 24), behavior: smooth ? 'smooth' : 'auto' });
          }
        } catch (error) {
          if (error.name === 'AbortError') return;
          window.location.href = url.pathname + url.search;
        }
      }
    }
    customElements.define('ao-collection-filters', AoCollectionFilters);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ao-main-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.customElements.get('ao-pdp')) return;

    function same(a, b, upto) {
      for (var j = 0; j < upto; j++) {
        if (a[j] !== b[j]) return false;
      }
      return true;
    }

    class AoPdp extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        var data = this.querySelector('[data-ao-pdp-variants]');
        try {
          this.variants = data ? JSON.parse(data.textContent) : [];
        } catch (e) {
          this.variants = [];
        }
        this.anyAvailable = this.variants.some(function (v) { return v.available; });
        this.form = this.querySelector('[data-ao-pdp-form]');
        this.idInput = this.querySelector('[data-ao-variant-id]');
        if (this.idInput) this.idInput.disabled = false;
        this.track = this.querySelector('[data-ao-track]');
        this.slides = this.track ? Array.prototype.slice.call(this.track.children) : [];
        this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-ao-thumb]'));
        this.caption = this.querySelector('[data-ao-caption]');
        this.index = 0;

        this.addEventListener('change', this.onChange.bind(this));
        this.addEventListener('click', this.onClick.bind(this));
        if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));
        if (this.track) {
          var self = this;
          var raf = 0;
          this.track.addEventListener('scroll', function () {
            cancelAnimationFrame(raf);
            raf = requestAnimationFrame(function () { self.syncFromScroll(); });
          }, { passive: true });
          this.track.addEventListener('keydown', function (e) {
            if (e.target !== self.track) return;
            var rtl = getComputedStyle(self.track).direction === 'rtl';
            var step = 0;
            if (e.key === 'ArrowRight') step = rtl ? -1 : 1;
            if (e.key === 'ArrowLeft') step = rtl ? 1 : -1;
            if (!step) return;
            e.preventDefault();
            self.goTo(self.index + step);
          });
        }
        this.loadModelViewer();
        this.staggerChips();
      }

      motion() {
        return !!(window.AoMotion && window.AoMotion.enabled());
      }

      // Facts chips stagger only when they start below the fold: in the
      // first viewport they are part of the buy area and stay static.
      staggerChips() {
        if (!this.motion()) return;
        var self = this;
        this.querySelectorAll('.ao-pdp__chips').forEach(function (list) {
          if (list.getBoundingClientRect().top < window.innerHeight) return;
          list.setAttribute('data-ao-stagger', 'fade');
          window.AoMotion.scan(list);
        });
      }

      swapIn(el, update) {
        if (!el) return;
        if (window.AoMotion) window.AoMotion.swap(el, update);
        else update();
      }

      // Thumb / variant switch: a snapshot of the current slide fades out
      // over the new one while the track jumps there (a crossfade, opacity
      // only). Swipe and arrow keys keep the native scroll-snap.
      crossfade(i) {
        i = Math.max(0, Math.min(this.slides.length - 1, i));
        var from = this.slides[this.index];
        if (i === this.index || !from || !this.motion() || from.querySelector('video, iframe, model-viewer')) {
          this.goTo(i);
          return;
        }
        var old = this.querySelector('.ao-pdp__ghost');
        if (old) old.remove();
        var ghost = document.createElement('div');
        ghost.className = 'ao-pdp__ghost';
        ghost.setAttribute('aria-hidden', 'true');
        ghost.inert = true;
        var snap = from.cloneNode(true);
        snap.removeAttribute('data-ao-reveal');
        snap.removeAttribute('data-ao-t');
        snap.removeAttribute('data-ao-in');
        snap.removeAttribute('role');
        snap.removeAttribute('aria-label');
        snap.removeAttribute('aria-roledescription');
        snap.style.aspectRatio = 'auto';
        snap.querySelectorAll('img').forEach(function (img) {
          img.removeAttribute('data-ao-img');
          img.setAttribute('data-ao-img-skip', '');
        });
        ghost.appendChild(snap);
        var t = this.track;
        ghost.style.left = t.offsetLeft + t.clientLeft + 'px';
        ghost.style.top = t.offsetTop + t.clientTop + 'px';
        ghost.style.width = t.clientWidth + 'px';
        ghost.style.height = t.clientHeight + 'px';
        ghost.addEventListener('animationend', function () { ghost.remove(); });
        t.parentNode.appendChild(ghost);
        this.goTo(i, true);
      }

      loadModelViewer() {
        if (!this.querySelector('model-viewer')) return;
        if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
          window.Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0' }]);
        }
      }

      goTo(i, instant) {
        if (!this.track || !this.slides.length) return;
        i = Math.max(0, Math.min(this.slides.length - 1, i));
        var slide = this.slides[i];
        var left = slide.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft;
        this.track.scrollTo({ left: left, behavior: instant ? 'instant' : undefined });
        this.setIndex(i);
      }

      syncFromScroll() {
        var tl = this.track.getBoundingClientRect().left;
        var best = 0;
        var bestD = Infinity;
        this.slides.forEach(function (s, n) {
          var d = Math.abs(s.getBoundingClientRect().left - tl);
          if (d < bestD) { bestD = d; best = n; }
        });
        this.setIndex(best);
      }

      setIndex(i) {
        if (i === this.index) return;
        this.index = i;
        this.thumbs.forEach(function (t, n) {
          if (n === i) t.setAttribute('aria-current', 'true');
          else t.removeAttribute('aria-current');
        });
        var active = this.thumbs[i];
        if (active && active.parentElement) {
          var strip = active.parentElement;
          var sl = strip.getBoundingClientRect();
          var al = active.getBoundingClientRect();
          if (al.left < sl.left || al.right > sl.right) {
            strip.scrollLeft += al.left - sl.left;
          }
        }
        if (this.caption && this.slides[i]) {
          var cap = this.caption;
          var next = this.slides[i].getAttribute('data-caption') || '';
          if (cap.textContent !== next) this.swapIn(cap, function () { cap.textContent = next; });
        }
        this.slides.forEach(function (s, n) {
          if (n === i) return;
          s.querySelectorAll('video').forEach(function (v) { v.pause(); });
        });
      }

      onClick(e) {
        var thumb = e.target.closest('[data-ao-thumb]');
        if (thumb) {
          this.crossfade(parseInt(thumb.getAttribute('data-ao-thumb'), 10));
          return;
        }
        var qtyBtn = e.target.closest('[data-ao-qty]');
        if (qtyBtn) {
          var input = this.querySelector('[data-ao-qty-input]');
          var next = (parseInt(input.value, 10) || 1) + parseInt(qtyBtn.getAttribute('data-ao-qty'), 10);
          this.swapIn(input, function () { input.value = Math.max(1, next); });
          this.syncQty();
        }
      }

      syncQty() {
        var input = this.querySelector('[data-ao-qty-input]');
        var dec = this.querySelector('[data-ao-qty="-1"]');
        if (!input || !dec) return;
        dec.disabled = (parseInt(input.value, 10) || 1) <= 1;
      }

      selected() {
        var out = [];
        this.querySelectorAll('.ao-pdp__option').forEach(function (fs, i) {
          var c = fs.querySelector('input[type="radio"]:checked');
          out[i] = c ? c.value : null;
        });
        return out;
      }

      usable(v) {
        return this.anyAvailable ? v.available : true;
      }

      onChange(e) {
        var t = e.target;
        if (t.matches('[data-ao-qty-input]')) {
          if (!(parseInt(t.value, 10) >= 1)) t.value = 1;
          this.syncQty();
          return;
        }
        if (!t.matches('[data-ao-opt]')) return;
        var oi = parseInt(t.getAttribute('data-ao-opt'), 10);
        var sel = this.selected();
        var self = this;
        var v = this.variants.find(function (x) { return same(x.options, sel, sel.length); });
        if (!v || !this.usable(v)) {
          v = this.variants.find(function (x) { return same(x.options, sel, oi + 1) && self.usable(x); }) || v;
        }
        if (v) this.apply(v);
      }

      apply(v) {
        var self = this;
        this.querySelectorAll('.ao-pdp__option').forEach(function (fs, i) {
          fs.querySelectorAll('input[type="radio"]').forEach(function (r) {
            r.checked = r.value === v.options[i];
            r.disabled = !self.variants.some(function (x) {
              return x.options[i] === r.value && same(x.options, v.options, i) && self.usable(x);
            });
          });
        });

        if (this.idInput) this.idInput.value = v.id;
        var price = this.querySelector('[data-ao-price]');
        if (price) {
          var probe = document.createElement('div');
          probe.innerHTML = v.price;
          if (price.textContent.trim() !== probe.textContent.trim()) this.swapIn(price, function () { price.innerHTML = v.price; });
          else price.innerHTML = v.price;
        }
        var title = this.querySelector('[data-ao-variant-title]');
        if (title && title.textContent !== v.title) this.swapIn(title, function () { title.textContent = v.title; });

        var add = this.querySelector('[data-ao-add]');
        var addText = this.querySelector('[data-ao-add-text]');
        if (add) add.disabled = !v.available;
        var label = v.available ? this.dataset.labelAdd : this.dataset.labelSoldOut;
        if (addText && addText.textContent !== label) this.swapIn(addText, function () { addText.textContent = label; });
        this.clearError();

        if (window.history && window.history.replaceState && /\/products\//.test(window.location.pathname)) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState(window.history.state, '', url.toString());
        }

        if (v.media) {
          var n = this.slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(v.media); });
          if (n > -1) this.crossfade(n);
        }
      }

      clearError() {
        var err = this.querySelector('[data-ao-error]');
        if (err) { err.textContent = ''; err.hidden = true; }
      }

      onSubmit(e) {
        if (!window.fetch || !window.FormData) return;
        e.preventDefault();
        var form = this.form;
        if (form.classList.contains('is-adding')) return;
        var self = this;
        var add = this.querySelector('[data-ao-add]');
        var addText = this.querySelector('[data-ao-add-text]');
        var status = this.querySelector('[data-ao-status]');
        var err = this.querySelector('[data-ao-error]');
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        this.clearError();
        form.classList.add('is-adding');
        if (add) add.setAttribute('aria-busy', 'true');

        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        })
          .then(function (res) {
            return res.json().then(function (body) { return { ok: res.ok, body: body }; });
          })
          .then(function (r) {
            if (!r.ok) {
              if (err) {
                err.textContent = (r.body && (r.body.description || r.body.message)) || self.dataset.labelError;
                err.hidden = false;
              }
              return;
            }
            var done = self.dataset.labelAdded;
            if (addText) addText.textContent = done;
            if (add) add.classList.add('is-done');
            if (status) status.textContent = done;
            document.dispatchEvent(new CustomEvent('ao:cart:added', { detail: { item: r.body } }));
            window.setTimeout(function () {
              if (addText && add && !add.disabled) addText.textContent = self.dataset.labelAdd;
              if (add) add.classList.remove('is-done');
              if (status) status.textContent = '';
            }, 2000);
          })
          .catch(function () {
            HTMLFormElement.prototype.submit.call(form);
          })
          .then(function () {
            form.classList.remove('is-adding');
            if (add) add.removeAttribute('aria-busy');
          });
      }
    }

    window.customElements.define('ao-pdp', AoPdp);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ao-main-search"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__aoMainSearch) return;
    window.__aoMainSearch = true;

    function base() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    function bind(root) {
      if (root.__aoBound) return;
      root.__aoBound = true;
      var form = root.querySelector('[data-ao-ms-form]');
      var input = root.querySelector('[data-ao-ms-input]');
      var clear = root.querySelector('[data-ao-ms-clear]');
      var list = root.querySelector('[data-ao-ms-list]');
      var live = root.querySelector('[data-ao-ms-live]');
      if (!form || !input || !list) return;
      var predictive = root.getAttribute('data-predictive') === 'true';
      var timer = null;
      var controller = null;
      var active = -1;
      var cancelSpin = null;

      // Motion (docs/motion.md §4.14): the list opens with op + 4 px (--dur-fast),
      // its rows fade in 30 ms apart (cap 6); while open, new results replay
      // swap() on the list; closing fades out in --dur-instant, then hides.
      // The loading row appears only after --loading-delay.
      function moving() {
        return !!(window.AoMotion && window.AoMotion.enabled());
      }
      function later(fn) {
        if (window.AoMotion) return window.AoMotion.later(fn);
        var id = window.setTimeout(fn, 150);
        return function () { window.clearTimeout(id); };
      }
      function stopSpin() {
        if (cancelSpin) cancelSpin();
        cancelSpin = null;
      }
      function finishClose() {
        list.classList.remove('is-closing', 'is-opening');
        list.hidden = true;
        list.innerHTML = '';
      }
      function show() {
        var opening = list.hidden || list.classList.contains('is-closing');
        list.classList.remove('is-closing');
        list.hidden = false;
        if (!moving()) return;
        if (!opening) {
          window.AoMotion.swap(list);
          return;
        }
        Array.prototype.forEach.call(list.children, function (li, i) { li.style.setProperty('--ao-ms-i', Math.min(i, 5)); });
        list.classList.remove('is-opening');
        void list.offsetWidth;
        list.classList.add('is-opening');
        Promise.all(list.getAnimations({ subtree: true }).map(function (a) { return a.finished; }))
          .then(function () { list.classList.remove('is-opening'); }, function () {});
      }
      list.addEventListener('animationend', function (e) {
        if (e.target === list && list.classList.contains('is-closing')) finishClose();
      });

      function options() {
        return Array.prototype.slice.call(list.querySelectorAll('[role="option"]'));
      }
      function close() {
        stopSpin();
        list.removeAttribute('aria-busy');
        active = -1;
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
        if (list.hidden || !moving()) {
          finishClose();
          return;
        }
        list.classList.remove('is-opening');
        list.classList.add('is-closing');
      }
      function setActive(i) {
        var opts = options();
        if (!opts.length) return;
        active = (i + opts.length) % opts.length;
        opts.forEach(function (o, n) { o.setAttribute('aria-selected', n === active ? 'true' : 'false'); });
        input.setAttribute('aria-activedescendant', opts[active].id);
        opts[active].scrollIntoView({ block: 'nearest' });
      }
      function option(id, href, title, kind, extraClass) {
        var li = document.createElement('li');
        li.setAttribute('role', 'presentation');
        var a = document.createElement('a');
        a.id = id;
        a.href = href;
        a.className = 'ao-ms__option' + (extraClass ? ' ' + extraClass : '');
        a.setAttribute('role', 'option');
        a.setAttribute('aria-selected', 'false');
        a.tabIndex = -1;
        var t = document.createElement('span');
        t.textContent = title;
        a.appendChild(t);
        if (kind) {
          var k = document.createElement('span');
          k.className = 'ao-ms__option-kind';
          k.textContent = kind;
          a.appendChild(k);
        }
        li.appendChild(a);
        return li;
      }
      function render(q, data) {
        var res = (data && data.resources && data.resources.results) || {};
        var items = [];
        (res.products || []).forEach(function (p) { items.push([p.url, p.title, root.getAttribute('data-kind-product')]); });
        (res.pages || []).forEach(function (p) { items.push([p.url, p.title, root.getAttribute('data-kind-page')]); });
        (res.articles || []).forEach(function (p) { items.push([p.url, p.title, root.getAttribute('data-kind-article')]); });
        stopSpin();
        list.innerHTML = '';
        active = -1;
        var prefix = list.id + '-opt-';
        items.forEach(function (it, i) { list.appendChild(option(prefix + i, it[0], it[1], it[2])); });
        var params = new URLSearchParams(new FormData(form));
        var all = (root.getAttribute('data-msg-all') || '').split('[terms]').join(q);
        list.appendChild(option(prefix + 'all', form.action + '?' + params.toString(), all, '', 'ao-ms__option--all'));
        show();
        input.setAttribute('aria-expanded', 'true');
        if (live) live.textContent = (root.getAttribute('data-msg-count') || '').split('[count]').join(String(items.length));
      }
      function loading(on) {
        var row = list.querySelector('[data-ao-ms-loading]');
        if (!on) {
          stopSpin();
          if (row) row.remove();
          list.removeAttribute('aria-busy');
          if (!list.children.length) finishClose();
          return;
        }
        list.setAttribute('aria-busy', 'true');
        if (row || cancelSpin) return;
        cancelSpin = later(function () {
          cancelSpin = null;
          if (list.querySelector('[data-ao-ms-loading]')) return;
          list.insertBefore(spinRow(), list.firstChild);
          show();
        });
      }
      function spinRow() {
        var row = document.createElement('li');
        row.className = 'ao-ms__loading';
        row.setAttribute('role', 'presentation');
        row.setAttribute('data-ao-ms-loading', '');
        var spin = document.createElement('span');
        spin.className = 'ao-spinner ao-spinner--sm';
        spin.setAttribute('aria-hidden', 'true');
        var text = document.createElement('span');
        text.textContent = root.getAttribute('data-msg-loading') || '';
        row.appendChild(spin);
        row.appendChild(text);
        return row;
      }
      function suggest() {
        var q = input.value.trim();
        if (q.length < 2) { close(); return; }
        loading(true);
        if (controller) controller.abort();
        controller = 'AbortController' in window ? new AbortController() : null;
        var url = base() + 'search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=' + encodeURIComponent(root.getAttribute('data-types') || 'product') +
          '&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, { headers: { Accept: 'application/json' }, signal: controller ? controller.signal : undefined })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) {
            if (input.value.trim() !== q || document.activeElement !== input) { loading(false); return; }
            list.removeAttribute('aria-busy');
            if (data) render(q, data); else close();
          })
          .catch(function (error) {
            if (!error || error.name !== 'AbortError') loading(false);
          });
      }

      input.addEventListener('input', function () {
        if (clear) clear.hidden = input.value === '';
        if (!predictive) return;
        window.clearTimeout(timer);
        timer = window.setTimeout(suggest, 220);
      });
      input.addEventListener('keydown', function (e) {
        if (list.hidden || list.classList.contains('is-closing')) return;
        if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
        else if (e.key === 'Escape') { e.preventDefault(); close(); }
        else if (e.key === 'Enter' && active > -1) {
          var opt = options()[active];
          if (opt) { e.preventDefault(); window.location.href = opt.href; }
        }
      });
      input.addEventListener('blur', function () {
        window.setTimeout(function () { if (!root.contains(document.activeElement)) close(); }, 150);
      });
      if (clear) {
        clear.addEventListener('click', function () {
          input.value = '';
          clear.hidden = true;
          close();
          input.focus();
        });
      }
      document.addEventListener('click', function (e) {
        if (!list.hidden && !form.contains(e.target)) close();
      });
    }

    function init() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-ao-main-search]'), bind);
    }
    document.addEventListener('shopify:section:load', init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ao-newsletter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(scope) {
      (scope || document).querySelectorAll('.ao-newsletter__form[id]').forEach(function (form) {
        if (window.location.hash !== '#' + form.id) return;
        form.setAttribute('data-ao-reveal', 'none');
        if (window.AoMotion) window.AoMotion.reveal(form);
        var success = form.querySelector('[data-ao-nl-success]');
        var error = form.querySelector('[data-ao-nl-error]');
        var fields = form.querySelector('[data-ao-nl-fields]');
        if (success) {
          success.hidden = false;
          if (fields) fields.hidden = true;
          success.focus();
        } else if (error) {
          error.hidden = false;
          var input = form.querySelector('input[type="email"]');
          if (input) {
            var described = (input.getAttribute('aria-describedby') || '').split(' ').filter(Boolean);
            if (described.indexOf(error.id) === -1) described.unshift(error.id);
            input.setAttribute('aria-invalid', 'true');
            input.setAttribute('aria-describedby', described.join(' '));
            input.focus();
          }
        }
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form.matches || !form.matches('.ao-newsletter__form')) return;
      var button = form.querySelector('.ao-newsletter__button');
      if (!button) return;
      var busy = function () { button.setAttribute('aria-busy', 'true'); };
      if (window.AoMotion) window.AoMotion.later(busy);
      else setTimeout(busy, 150);
    });
    window.addEventListener('pageshow', function () {
      document.querySelectorAll('.ao-newsletter__button[aria-busy]').forEach(function (button) {
        button.removeAttribute('aria-busy');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ao-our-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (document.aoOurStoryBound) return;
    document.aoOurStoryBound = true;

    function setPlayingText(root, playing) {
      root.querySelectorAll('.ao-os__when-playing').forEach(function (el) {
        el.hidden = !playing;
      });
    }

    function stop(root, link) {
      var frame = root.querySelector('[data-ao-os-frame]');
      var embed = frame && frame.querySelector('.ao-os__embed');
      if (embed) embed.remove();
      var figure = root.querySelector('[data-ao-os-figure]');
      if (figure && root.classList.contains('ao-os--solo')) figure.hidden = true;
      root.classList.remove('is-playing');
      setPlayingText(root, false);
      link.setAttribute('aria-pressed', 'false');
    }

    function play(root, link) {
      var frame = root.querySelector('[data-ao-os-frame]');
      if (!frame) return;
      var iframe = document.createElement('iframe');
      iframe.className = 'ao-os__embed';
      iframe.src = link.getAttribute('data-embed');
      iframe.title = link.getAttribute('data-title') || '';
      iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      frame.appendChild(iframe);
      var figure = root.querySelector('[data-ao-os-figure]');
      if (figure) figure.hidden = false;
      root.classList.add('is-playing');
      setPlayingText(root, true);
      link.setAttribute('aria-pressed', 'true');
    }

    function upgrade(scope) {
      (scope || document).querySelectorAll('[data-ao-os-film]').forEach(function (link) {
        link.setAttribute('role', 'button');
        link.setAttribute('aria-pressed', 'false');
      });
    }

    document.addEventListener('click', function (event) {
      var link = event.target.closest('[data-ao-os-film]');
      if (!link) return;
      var root = link.closest('[data-ao-os]');
      if (!root) return;
      event.preventDefault();
      if (root.classList.contains('is-playing')) {
        stop(root, link);
      } else {
        play(root, link);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== ' ') return;
      var link = event.target.closest && event.target.closest('[data-ao-os-film]');
      if (!link) return;
      event.preventDefault();
      link.click();
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { upgrade(); });
    } else {
      upgrade();
    }
    document.addEventListener('shopify:section:load', function (event) { upgrade(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ao-provenance"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function measure(root) {
      (root || document).querySelectorAll('.ao-pv--clamp[data-ao-pv]').forEach(function (wrap) {
        var story = wrap.querySelector('.ao-pv__story');
        var toggle = wrap.querySelector('.ao-pv__toggle');
        if (!story || (toggle && toggle.checked)) return;
        wrap.classList.remove('is-short');
        if (story.scrollHeight <= story.clientHeight + 24) wrap.classList.add('is-short');
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { measure(); });
    } else {
      measure();
    }
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () { measure(); }, 150);
    });
    document.addEventListener('shopify:section:load', function (e) { measure(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ao-related-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!window.customElements || customElements.get('ao-related-products')) return;

    class AoRelatedProducts extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded === 'true') {
          this.initRail();
          return;
        }
        if (!this.dataset.url || this._loading) return;
        this._loading = true;
        fetch(this.dataset.url)
          .then(function (response) {
            if (!response.ok) throw new Error('recommendations ' + response.status);
            return response.text();
          })
          .then((html) => {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var found = doc.querySelector('.ao-rp');
            if (found && found.querySelector('.ao-rp__item:not([data-ao-skeleton])')) {
              var seenHead = this.querySelector('.ao-rp__plinth > [data-ao-in]');
              this.innerHTML = '';
              this.appendChild(document.importNode(found, true));
              this.dataset.loaded = 'true';
              this.initRail();
              if (window.AoMotion) {
                var head = this.querySelector('.ao-rp__plinth');
                window.AoMotion.scan(this);
                if (seenHead && head) window.AoMotion.reveal(head);
              }
            } else {
              this.showEmpty();
            }
          })
          .catch(() => this.showEmpty());
      }

      showEmpty() {
        var note = this.dataset.editorEmpty;
        if (!note) {
          this.hidden = true;
          return;
        }
        var wrap = document.createElement('div');
        wrap.className = 'ao-scope ao-rp ao-rp--placeholder';
        var inner = document.createElement('div');
        inner.className = 'ao-container';
        var p = document.createElement('p');
        p.className = 'ao-rp__placeholder';
        p.textContent = note;
        inner.appendChild(p);
        wrap.appendChild(inner);
        this.innerHTML = '';
        this.appendChild(wrap);
      }

      initRail() {
        var root = this.querySelector('.ao-rp');
        var rail = this.querySelector('[data-ao-rp-rail]');
        if (!root || !rail || rail._aoBound) return;
        rail._aoBound = true;
        var buttons = this.querySelectorAll('[data-ao-rp-dir]');

        var update = function () {
          var max = rail.scrollWidth - rail.clientWidth;
          root.classList.toggle('is-static', max <= 2);
          var refocus = null;
          buttons.forEach(function (b) {
            var dir = Number(b.getAttribute('data-ao-rp-dir'));
            var off = dir < 0 ? rail.scrollLeft <= 2 : rail.scrollLeft >= max - 2;
            if (off && document.activeElement === b) refocus = b;
            b.disabled = off;
          });
          if (refocus) {
            buttons.forEach(function (b) {
              if (b !== refocus && !b.disabled) b.focus({ preventScroll: true });
            });
          }
        };

        buttons.forEach(function (b) {
          b.addEventListener('click', function () {
            var item = rail.querySelector('.ao-rp__item');
            var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
            var step = item ? item.getBoundingClientRect().width + gap : 300;
            var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            rail.scrollBy({ left: Number(b.getAttribute('data-ao-rp-dir')) * step, behavior: smooth ? 'smooth' : 'auto' });
          });
        });

        var t;
        rail.addEventListener('scroll', function () {
          clearTimeout(t);
          t = setTimeout(update, 60);
        }, { passive: true });
        window.addEventListener('resize', update);
        update();
      }
    }

    customElements.define('ao-related-products', AoRelatedProducts);
  })();

  } catch(e) { console.error(e); }
})();
})();
